import { Clipboard } from 'react-native';
import { MultipleOptions, OpenReturn, Options } from 'react-native-share';

class Share {
  static open(options: Options | MultipleOptions): Promise<OpenReturn> {
    const content = options.url || options.message || options.subject || '';
    Clipboard.setString(content);
    const res: Promise<OpenReturn> = new Promise((resolve) => {
      resolve({ app: '', dismissedAction: true });
    });

    return res;
  }
}

export default Share;
